<ion-content>
  <ion-radio-group [(ngModel)]="editorFilter" mode="md" (ionChange)="newEditorFilterSelected(editorFilter)">
    <ion-item>
      <ion-radio slot="start" value="all" labelPlacement="end">Alle</ion-radio>
    </ion-item>
    <ion-item>
      <ion-radio slot="start" value="onlyEditor" labelPlacement="end">Bearbeiter</ion-radio>
    </ion-item>
    <ion-item>
      <ion-radio slot="start" value="onlyViewer" labelPlacement="end">Beobachter</ion-radio>
    </ion-item>
  </ion-radio-group>
</ion-content>